import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    appSettings: (config: AxiosRequestConfig) => api.get(`/location/settings`, config),
    translate: (config: AxiosRequestConfig) => api.get(`/translate`, config),
    update: (data: object, config: AxiosRequestConfig) =>
        api.put(`/location/settings`, data, config),
};

export default requests;
